import { render } from "./ClassCreatePage.vue?vue&type=template&id=3a9d31b6"
import script from "./ClassCreatePage.vue?vue&type=script&lang=js"
export * from "./ClassCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__